/**
 * Utility functions for persisting language preference through authentication flow
 */

const LANGUAGE_STORAGE_KEY = 'airteam_language';

/**
 * Store language preference in localStorage
 * @param {string} language - Language code (de, en)
 */
export const storeLanguagePreference = (language) => {
  if (language && (language === 'de' || language === 'en')) {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }
};

/**
 * Get stored language preference from localStorage
 * @returns {string|null} - Language code or null if not found
 */
export const getStoredLanguagePreference = () => {
  return localStorage.getItem(LANGUAGE_STORAGE_KEY);
};

/**
 * Clear stored language preference
 */
export const clearLanguagePreference = () => {
  localStorage.removeItem(LANGUAGE_STORAGE_KEY);
};

/**
 * Build URL with language parameter
 * @param {string} path - Base path
 * @param {string} language - Language code
 * @returns {string} - URL with language parameter
 */
export const buildUrlWithLanguage = (path, language) => {
  if (!language) return path;
  
  const url = new URL(path, window.location.origin);
  url.searchParams.set('lang', language);
  return url.pathname + url.search;
}; 